<template>
  <div class="contents">
    <div class="container-fluid">
      <div class="breadcrumb-main user-member justify-content-sm-between mb-3">
        <h4 class="text-capitalize fw-500 breadcrumb-title">
          <a @click="$router.go(-1)" style="cursor:pointer"><i class="fas fa-arrow-left"></i></a>
          &nbsp; Kategori Produk
        </h4>
        <div class="action-btn">
          <button class="btn btn-primary text-white" @click="openAdd">
            <i class="fas fa-plus"></i> Tambah Kategori
          </button>
        </div>
      </div>

      <div class="card p-3 border bg-white radius-xl">
        <div v-if="isLoading" class="text-center"><div class="spinner-border"></div></div>
        <div v-else-if="categories.length === 0" class="text-center text-muted p-4">Belum ada kategori.</div>
        <table v-else class="table">
          <thead><tr><th>Nama</th><th>Slug</th><th>Sort</th><th class="text-right">Action</th></tr></thead>
          <tbody>
            <tr v-for="c in categories" :key="c.id">
              <td><b>{{ c.name }}</b></td>
              <td><code>{{ c.slug }}</code></td>
              <td>{{ c.sort_order }}</td>
              <td class="text-right">
                <button class="btn btn-sm btn-primary" @click="openEdit(c)"><i class="fas fa-edit"></i></button>
                <button class="btn btn-sm btn-danger ml-1" @click="del(c)"><i class="fas fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <modal name="cat_form" :height="'auto'" :adaptive="true">
        <div class="p-4">
          <h4>{{ editId ? 'Edit' : 'Tambah' }} Kategori</h4>
          <form @submit.prevent="save">
            <label>Nama</label>
            <input v-model="form.name" class="form-control mb-2" required>
            <label>Slug (otomatis kalau kosong)</label>
            <input v-model="form.slug" class="form-control mb-2">
            <label>Sort Order</label>
            <input v-model.number="form.sort_order" type="number" class="form-control mb-3">
            <div class="text-right">
              <button type="button" class="btn btn-secondary" @click="$modal.hide('cat_form')">Batal</button>
              <button type="submit" class="btn btn-primary ml-2">Simpan</button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopId: null, categories: [], isLoading: false, editId: null,
      form: { name: '', slug: '', sort_order: 0 },
    };
  },
  mounted() {
    this.shopId = this.$route.params.id;
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('shop_category/shop_category_list', this.shopId);
        this.categories = this.$store.state.shop_category.categories;
      } catch (e) { this.$toast.error('Gagal load'); }
      this.isLoading = false;
    },
    openAdd() {
      this.editId = null;
      this.form = { name: '', slug: '', sort_order: 0 };
      this.$modal.show('cat_form');
    },
    openEdit(c) {
      this.editId = c.id;
      this.form = { name: c.name, slug: c.slug, sort_order: c.sort_order };
      this.$modal.show('cat_form');
    },
    async save() {
      try {
        if (this.editId) {
          await this.$store.dispatch('shop_category/shop_category_update', { shopId: this.shopId, id: this.editId, payload: this.form });
        } else {
          await this.$store.dispatch('shop_category/shop_category_create', { shopId: this.shopId, payload: this.form });
        }
        this.$toast.success('Tersimpan');
        this.$modal.hide('cat_form');
        this.load();
      } catch (e) { this.$toast.error(e.response?.data?.message || 'Gagal'); }
    },
    async del(c) {
      if (!confirm('Hapus kategori "' + c.name + '"?')) return;
      try {
        await this.$store.dispatch('shop_category/shop_category_delete', { shopId: this.shopId, id: c.id });
        this.$toast.success('Dihapus');
        this.load();
      } catch (e) { this.$toast.error(e.response?.data?.message || 'Gagal'); }
    },
  },
};
</script>
